import type { ReactNode } from 'react';
import { cn } from '@/utils/classnames';

export function PageHeader({ title, subtitle, meta }: { title: string; subtitle: ReactNode; meta?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-stack-md">
      <div>
        <h2 className="font-headline-lg text-headline-lg text-on-surface">{title}</h2>
        <p className="mt-unit font-body-sm text-body-sm text-on-surface-variant">{subtitle}</p>
      </div>
      {meta ? <span className="font-label-caps text-label-caps uppercase text-on-surface-variant">{meta}</span> : null}
    </div>
  );
}

export function Panel({ title, children, className }: { title?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={cn('overflow-hidden rounded border border-outline-variant bg-surface', className)}>
      {title ? <header className="border-b border-outline-variant bg-[#EBECF0] px-container-padding py-stack-sm font-label-caps text-label-caps uppercase text-on-surface">{title}</header> : null}
      <div className="p-container-padding">{children}</div>
    </section>
  );
}

export function Th({ children }: { children: ReactNode }) {
  return <th className="p-table-cell-padding font-semibold">{children}</th>;
}

export function Td({ children, className }: { children: ReactNode; className?: string }) {
  return <td className={cn('p-table-cell-padding align-middle', className)}>{children}</td>;
}

export function TextInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={cn('h-8 rounded border border-outline-variant bg-surface px-stack-sm py-1 font-body-sm text-body-sm text-on-surface focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary', props.className)} />;
}

export function Select(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={cn('h-8 rounded border border-outline-variant bg-surface px-stack-sm py-1 font-body-sm text-body-sm text-on-surface focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary', props.className)} />;
}

export function PrimaryButton(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button {...props} className={cn('inline-flex items-center gap-unit rounded bg-primary-container px-stack-md py-stack-sm font-label-caps text-label-caps uppercase text-on-primary transition-colors hover:bg-primary disabled:cursor-not-allowed disabled:opacity-60', props.className)} />;
}

export function DangerButton(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button {...props} className={cn('inline-flex items-center gap-unit rounded bg-error px-stack-md py-stack-sm font-label-caps text-label-caps uppercase text-on-error transition-colors hover:bg-error/90 disabled:cursor-not-allowed disabled:opacity-60', props.className)} />;
}
